import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './SearchInput.css'

const SearchInput = props => {
  const className = classnames({
    SearchInput: true,
    'no-border': props.noBorder
  })
  return (
    <div className={className} style={{ width: props.width }}>
      <input type='text'
        name={props.name}
        defaultValue={props.defaultValue}
        value={props.value}
        placeholder={props.placeholder}
        onChange={e => props.onChange(e.target.value)} />
    </div>
  )
}

SearchInput.displayName = 'SearchInput'

SearchInput.defaultProps = {
  name: 'search',
  onChange () {},
  width: 'auto'
}

SearchInput.propTypes = {
  noBorder: PropTypes.bool,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
}

export default SearchInput



// WEBPACK FOOTER //
// ./ui/SearchInput.js